// extracted by mini-css-extract-plugin
export const cover = "big-modules--cover--k1yWI";
export const coverImageAsBackground = "big-modules--coverImageAsBackground--3sgQB";
export const coverImageAsImg = "big-modules--coverImageAsImg--2rHrI";
export const footer = "big-modules--footer--3TeYR";
export const footerHoverBlock = "big-modules--footerHoverBlock--3ko_X";